import RecurringDownloadReportPage from "./pages/RecurringDownloadReportPage";

export const recurringRoutes = (prefix = "recurring") => [
  {
    name: "RecurringDownloadReportPage",
    path: `${prefix}/report`,
    component: RecurringDownloadReportPage
  }
];
